<div class="outer-shell boldText fw-bold" [class.no-minutes]="waitMinutes === 'N/A'">
  {{ waitMinutes }}
</div>
